import {
  authorizeDeleteRequest,
  authorizeGetRequest,
  authorizePatchRequest,
  authorizePostRequest,
  authorizePutRequest,
  getRequest,
} from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import {
  IBanDriver,
  ICreateDriver,
  IDriver,
  IDriverUpdateInput,
} from "models/driver";
import { IDriverStatisticsResponse } from "models/driverStatistics";

export const driversApi = (page: number, perPage: number, search: string, useCache: boolean = false) => {
  if (search) search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<IDriver>>(
    `drivers?page=${page}&per_page=${perPage}&query=${search}`,
    useCache
  );
};

export const driverStatisticsApi = (date?: string, limit: number = 10, useCache: boolean = false) => {
  const params = new URLSearchParams();
  if (date) params.append("date", date);
  if (limit) params.append("limit", limit.toString());
  const queryString = params.toString();
  return authorizeGetRequest<IDriverStatisticsResponse>(
    `drivers/rankings/daily${queryString ? `?${queryString}` : ""}`,
    useCache
  );
};


export const createDriverApi = (data: ICreateDriver) => {
  if (data.driver.email && data.driver.email.trim() === "")
    data.driver.email = null;
  data.driver.date_of_birth = new Date(data.driver.date_of_birth).toISOString();
  return authorizePostRequest<IApiResponse<IDriver>>("drivers", data);
};

export const updateDriverApi = (id: string, data: IDriverUpdateInput) => {
  if (data.email && data.email.trim() === "") data.email = null;
  data.date_of_birth = new Date(data.date_of_birth).toISOString();
  return authorizePatchRequest<IApiResponse<IDriver>>(`drivers/${id}`, data);
};

export const deleteDriverApi = (id: string) => {
  return authorizeDeleteRequest<IApiResponse<IDriver>>(`drivers/${id}`);
};

export const fetchDriverByIdApi = (id: string) => {
  return authorizeGetRequest<IApiResponse<IDriver>>(`drivers/${id}`);
};

export const fetchDriverByIdQrcode = (qrcode: string) => {
  return getRequest<IApiResponse<IDriver>>(`drivers/${qrcode}/qrcode`);
};

export const activateDriverByIdApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IDriver>>(
    `drivers/${id}/activate`,
    {}
  );
};

export const banDriverByIdApi = (id: string, input: IBanDriver) => {
  return authorizePutRequest<IApiResponse<IDriver>>(`drivers/${id}/ban`, input);
};

export const verifyDriverByIdApi = (id: string) => {
  return authorizePutRequest<IApiResponse<IDriver>>(`drivers/${id}/verify`, {});
};
